export default "__VITE_ASSET__70d8ff09__"